<template>
  <a-layout class="live-lottery">
    <div class="content-base">
      <div v-if="submitting" class="loading-container">
        <span class="loading-logo" />
        <p class="loading-text">{{ labels.loadingText }}</p>
      </div>
      <template v-if="!submitting && allm">
        <live-lottery-iframe :authToken="authToken" />
      </template>
    </div>
  </a-layout>
</template>
<script>
import loadingMixin from "@/mixins/loadingMixin";
import labels from "@/utils/labels";
import { pageTitle } from "../../utils/utils";
import { mapGetters } from "vuex";

import LiveLotteryIframe from "@/components/LiveLotteryIFrame.vue";
import { mapActions } from "vuex/dist/vuex.common.js";

export default {
  components: {
    LiveLotteryIframe,
  },
  mixins: [loadingMixin],
  name: "LiveLottery",
  metaInfo: {
    title: pageTitle(labels.liveLottery.title),
    meta: [
      {
        name: "title",
        content: labels.appName,
      },
      {
        name: "description",
        content: labels.liveLottery.title,
      },
    ],
  },
  beforeRouteEnter(_to, _from, next) {
    next((vm) => {
      vm.checkUserAllowed();
    });
  },
  data() {
    return {
      labels: { ...labels.liveLottery },
      submitting: true,
      authToken: null,
    };
  },
  computed: {
    ...mapGetters({
      loggedUser: "clientAuth/getLoggedUser",
    }),
    allm() {
      return this.loggedUser?.allm || false;
    },
  },
  methods: {
    ...mapActions("clientAuth", ["getLiveLotteryAuth"]),
    async getAuthToken() {
      this.submitting = true;
      try {
        const response = await this.getLiveLotteryAuth();
        this.authToken = response.data.token;
      } catch (error) {
        this.$message.error(this.labels.errorLoadingIframe);
      } finally {
        this.submitting = false;
      }
    },
    checkUserAllowed() {
      if (!this.allm) {
        this.$router.push({ name: "home" });
      } else {
        this.getAuthToken();
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@/assets/scss/variable";
.live-lottery {
  font-family: "Roboto", sans-serif;
  background-color: transparent;
  max-width: 100% !important;
  padding-bottom: 0;
  .content-base {
    border: none;
    background-color: transparent;
    @media screen and (max-width: $screen-mobile) {
      margin-top: 14px;
      max-width: calc(100% - 1.5rem) !important;
      margin-left: 0.75rem;
      margin-right: 0.75rem;
    }
    .loading-container {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      min-height: calc(100vh - 84px - 74px - 60px);
      .loading-logo {
        background-image: var(--banner-bg-collapsed);
        background-size: contain;
        background-repeat: no-repeat;
        width: 120px;
        height: 120px;
        animation: wave 3s infinite alternate;
      }
      .loading-text {
        font-size: 1.5rem;
        color: var(--text-active);
        margin-top: 1rem;
      }

      // bg keyframes for wave animation
      @keyframes wave {
        0% {
          transform: translateY(0);
          filter: blur(0px); /* Sin desenfoque */
        }
        50% {
          transform: translateY(10px); /* Ondulación vertical */
          filter: blur(0.5px); /* Un poco de desenfoque */
        }
        100% {
          transform: translateY(0);
          filter: blur(0px); /* Sin desenfoque */
        }
      }
    }
  }
}
</style>
